/* eslint-disable */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'utils/axios';

const name = 'Employees';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
    name,
    initialState,
    extraReducers
});

function createInitialState() {
    return {
        error: null,
        employee: [],
        managers: [],
        loading: false,
        totalData: 0,
        singleEmployee: {},
        selectedEmployeeAttendance: []
    };
}

function createExtraActions() {
    return {
        fetchDonutAnalytics: fetchDonutAnalytics(),
        fetchTableAnalytics: fetchTableAnalytics(),
        fetchLineGraphAnalytics: fetchLineGraphAnalytics(),
        fetchClicksDataAnalytics: fetchClicksDataAnalytics(),
        fetchSingleAnalytics: fetchSingleAnalytics(),
        fetchEmployees: fetchEmployees(),
        sendOnBoardEmail: sendOnBoardEmail(),
        createEmployee: createEmployee(),
        fetchEmployeeById: fetchEmployeeById(),
        fetchEmployeeContacts: fetchEmployeeContacts(),
        deleteEmployee: deleteEmployee(),
        updateEmployee: updateEmployee(),
        verifyEmployeeData: verifyEmployeeData(),
        createMultipleEmployee: createMultipleEmployee(),
        getMyApartmentManagers: getMyApartmentManagers(),
        addApartmentManagers: addApartmentManagers(),
        deleteApartmentManagers: deleteApartmentManagers(),
        verifyRegionalManagers: verifyRegionalManagers(),
        getRegionalManagersQueue: getRegionalManagersQueue(),
        fetchAnaylticsData: fetchAnaylticsData(),
        editSettings: editSettings(),
        getUserSettings: getUserSettings(),
        editInvoiceSettings: editInvoiceSettings()
    };
}

// create api
function fetchTableAnalytics() {
    return createAsyncThunk(`${name}/fetchTableAnalytics`, async ({ token, userId }) => {
        try {
            if (token) {
                const { data } = await axios.get(`/analytics/table`, {
                    params: { userId },
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                });
                return data;
            } else {
                const response = await axios.get(`/analytics/table`, { params: { userId } });
                return response.data;
            }
        } catch (err) {
            throw err;
        }
    });
}

function fetchAnaylticsData() {
    return createAsyncThunk(`${name}/fetchAnaylticsData`, async ({ id, token }) => {
        try {
            if (token) {
                const { data } = await axios.get(`/urlShortner/visits/${id}`, {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                });
                return data;
            } else {
                const response = await axios.get(`/urlShortner/visits/${id}`);
                return response.data;
            }
        } catch (err) {
            throw err;
        }
    });
}

function fetchSingleAnalytics() {
    return createAsyncThunk(`${name}/fetchSingleAnalytics`, async ({ id, token }) => {
        try {
            if (token) {
                const { data } = await axios.get(`/analytics/listing/${id}`, {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                });
                return data;
            } else {
                const response = await axios.get(`/analytics/listing/${id}`);
                return response.data;
            }
        } catch (err) {
            throw err;
        }
    });
}

function fetchLineGraphAnalytics() {
    return createAsyncThunk(`${name}/fetchLineGraphAnalytics`, async ({ timeType, fields, startDate, endDate, userId, token }) => {
        try {
            let route = `/analytics/graph`;

            // Convert array into query string
            let fieldsQueryString = fields.map((field) => `fields=${field}`).join('&');

            // Construct the full route with query parameters
            let fullRoute = `${route}?timeType=${timeType}&${fieldsQueryString}`;

            // Add startDate and endDate if available
            if (startDate) fullRoute += `&startDate=${startDate}`;
            if (endDate) fullRoute += `&endDate=${endDate}`;
            if (userId) fullRoute += `&userId=${userId}`;

            if (token) {
                const { data } = await axios.get(fullRoute, {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                });
                return data;
            } else {
                const response = await axios.get(fullRoute);
                return response.data;
            }
        } catch (err) {
            throw err;
        }
    });
}

function fetchClicksDataAnalytics() {
    return createAsyncThunk(`${name}/fetchClicksDataAnalytics`, async ({ timeType, fields, startDate, endDate, userId, token }) => {
        try {
            let route = `/analytics/clicks`;

            if (token) {
                const { data } = await axios.get(route, {
                    params: {
                        timeType,
                        startDate,
                        endDate,
                        userId,
                        ...fields?.map((e) => ({ fields: e }))
                    },
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                });
                return data;
            } else {
                const response = await axios.get(route, {
                    params: {
                        timeType,
                        startDate,
                        endDate,
                        userId
                    }
                });
                return response.data;
            }
        } catch (err) {
            throw err;
        }
    });
}

function fetchDonutAnalytics() {
    return createAsyncThunk(`${name}/fetchDonutAnalytics`, async ({ timeType, fields, startDate, endDate, userId, token }) => {
        try {
            let route = `/analytics/donut`;

            // Convert array into query string
            let fieldsQueryString = fields.map((field) => `fields=${field}`).join('&');

            // Construct the full route with query parameters
            let fullRoute = `${route}?timeType=${timeType}&${fieldsQueryString}`;

            // Add startDate and endDate if available
            if (startDate) fullRoute += `&startDate=${startDate}`;
            if (endDate) fullRoute += `&endDate=${endDate}`;
            if (userId) fullRoute += `&userId=${userId}`;

            if (token) {
                const { data } = await axios.get(fullRoute, {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                });
                return data;
            } else {
                const response = await axios.get(fullRoute);
                return response.data;
            }
        } catch (err) {
            throw err;
        }
    });
}

function fetchEmployees() {
    return createAsyncThunk(`${name}/fetchEmployees`, async ({ page, limit, search, status, emp_type, sortByKey, sortByType }) => {
        try {
            let route = `/user`;

            let params = {};
            if (page !== undefined) params.page = page;
            if (limit !== undefined) params.limit = limit;
            if (status) params.status = status;
            if (search) params.search = search;
            if (emp_type) params.roleName = emp_type;
            if (sortByType) params.sortByType = sortByType;
            if (sortByKey) params.sortByKey = sortByKey;

            const response = await axios.get(route, { params });
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function sendOnBoardEmail() {
    return createAsyncThunk(`${name}/sendOnBoardEmail`, async (id) => {
        try {
            const response = await axios.post(`/user/onboard/${id}`);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function fetchEmployeeById() {
    return createAsyncThunk(`${name}/fetchEmployeeById`, async (id) => {
        try {
            const response = await axios.get(`/user/${id}`);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function fetchEmployeeContacts() {
    return createAsyncThunk(`${name}/fetchEmployeeContacts`, async ({ search, rm }) => {
        try {
            let route = `/user/contacts`;

            let params = {};
            if (search) params.search = search;
            if (rm) params.rm = rm;

            const response = await axios.post(route, params);
            return response.data;
        } catch (err) {
            throw err;
        }
    });
}

function getUserSettings() {
    return createAsyncThunk(`${name}/getsettings`, async (userId = null) => {
        try {
            let url = `/settings/user`;
            if (userId) {
                url = `/settings/user/${userId}`;
            }
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            return err;
        }
    });
}

function createEmployee() {
    return createAsyncThunk(`${name}/createEmployee`, async (user) => {
        try {
            const response = await axios.post(`/user`, user);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function editSettings() {
    return createAsyncThunk(`${name}/editsettings`, async ({ userId = null, ...data }) => {
        try {
            let url = `/settings/user`;
            if (userId) {
                url = `/settings/user/${userId}`;
            }
            const response = await axios.patch(url, data);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function editInvoiceSettings() {
    return createAsyncThunk(`${name}/editInvoiceSettings`, async (data) => {
        try {
            const response = await axios.patch(`/settings/payment`, data?.values);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function createMultipleEmployee() {
    return createAsyncThunk(`${name}/createMultipleEmployee`, async (formData) => {
        try {
            const response = await axios.post(`/user/create-multiple`, formData, {
                headers: {
                    'Content-Type': 'multipart/formdata'
                }
            });
            return response;
        } catch (err) {
            return err;
        }
    });
}

function updateEmployee() {
    return createAsyncThunk(`${name}/updateEmployee`, async ({ data, id }) => {
        try {
            const response = await axios.patch(`/user/${id}`, data);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function deleteEmployee() {
    return createAsyncThunk(`${name}/deleteEmployee`, async (user) => {
        try {
            const response = await axios.delete(`/user`, { data: user });
            return response;
        } catch (err) {
            return err;
        }
    });
}

function verifyEmployeeData() {
    return createAsyncThunk(`${name}/verifyEmployeeData`, async ({ data }) => {
        try {
            const response = await axios.post(`/user/verify`, data);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function getMyApartmentManagers() {
    return createAsyncThunk(`${name}/getMyApartmentManagers`, async ({ page, limit, search }) => {
        try {
            let route = `/user/myApartmentManagers`;

            let params = {};
            if (page !== undefined) params.page = page;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;

            const response = await axios.get(route, { params });
            return response?.data;
        } catch (err) {
            return err;
        }
    });
}

function getRegionalManagersQueue() {
    return createAsyncThunk(`${name}/getRegionalManagersQueue`, async ({ page, limit, search }) => {
        try {
            let route = `/user/regionalManagerQueue`;

            let params = {};
            if (page !== undefined) params.page = page;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;

            const response = await axios.get(route, { params });
            return response?.data;
        } catch (err) {
            return err;
        }
    });
}

function verifyRegionalManagers() {
    return createAsyncThunk(`${name}/verifyRegionalManagers`, async (data) => {
        try {
            const response = await axios.post(`/user/verifyRegionalManager`, data);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function addApartmentManagers() {
    return createAsyncThunk(`${name}/addApartmentManagers`, async (id) => {
        try {
            const response = await axios.post(`/user/apartmentManager/${id}`);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function deleteApartmentManagers() {
    return createAsyncThunk(`${name}/deleteApartmentManagers`, async (id) => {
        try {
            const response = await axios.delete(`/user/apartmentManager/${id}`);
            return response;
        } catch (err) {
            return err;
        }
    });
}

function createExtraReducers() {
    return {
        ...fetchEmployees(),
        ...createEmployee(),
        ...fetchEmployeeById(),
        ...deleteEmployee(),
        ...getApartmentManagers(),
        ...getRegionalMangersQueue(),
        ...fetchEmployeeContacts()
    };

    function fetchEmployees() {
        const { pending, fulfilled, rejected } = extraActions.fetchEmployees;
        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
                state.employee = action.payload.users;
                state.totalData = action.payload?.totalUsers;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }

    function getApartmentManagers() {
        const { pending, fulfilled, rejected } = extraActions.getMyApartmentManagers;
        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
                state.managers = action.payload?.apartmentManagers;
                state.totalData = action.payload?.totalApartmentManagers;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }

    function getRegionalMangersQueue() {
        const { pending, fulfilled, rejected } = extraActions.getRegionalManagersQueue;
        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
                state.managers = action.payload?.approvalQueue;
                state.totalData = action.payload?.totalItems;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }

    function fetchEmployeeById() {
        const { pending, fulfilled, rejected } = extraActions.fetchEmployeeById;
        return {
            [pending]: (state) => {
                state.loading = true;
                state.singleEmployee = {};
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
                state.singleEmployee = action.payload;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.singleEmployee = {};
            }
        };
    }

    function fetchEmployeeContacts() {
        const { pending, fulfilled, rejected } = extraActions.fetchEmployeeContacts;
        return {
            [pending]: (state) => {
                state.loading = true;
            },
            [fulfilled]: (state, action) => {
                state.loading = false;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            }
        };
    }

    function deleteEmployee() {
        const { pending, fulfilled, rejected } = extraActions.deleteEmployee;
        return {
            [pending]: (state) => {},
            [fulfilled]: (state, action) => {
                const ids = action?.payload?.data?.deletedUsers;
                state.employee = state?.employee?.filter((emp) => !ids?.includes(emp?.user_id));
                state.totalData = state.totalData - ids?.length;
                state.loading = false;
            },
            [rejected]: (state, action) => {
                state.loading = false;
                state.error = action.error;
            }
        };
    }
}

export const EmployeeActions = { ...slice.actions, ...extraActions };

export default slice.reducer;
